
import React from 'react';
import { useAppContext } from '../../hooks/useAppContext';
import { Notification } from '../ui/Notification';

const NotificationContainer: React.FC = () => {
  const { notifications, removeNotification } = useAppContext();

  return (
    <div className="pointer-events-none fixed inset-x-3 top-20 z-[60] flex max-h-[65vh] flex-col gap-3 overflow-hidden sm:inset-x-auto sm:top-auto sm:bottom-4 sm:right-4 sm:w-full sm:max-w-sm">
      {notifications.map(notification => (
        <Notification
          key={notification.id}
          message={notification.message}
          type={notification.type}
          count={notification.count}
          onClose={() => removeNotification(notification.id)}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;
